import { trackEvent } from "@faire/web--source/common/trackEvent";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import React from "react";

const buildVisibilityEventPath = (name: string) =>
  `logged-out-category-page/${name}/visible`;

export const VisibilityTracker: React.FC<
  React.PropsWithChildren<{ name: string }>
> = ({ name, children }) => {
  const viewRef = useDoActionWhenVisible(() => {
    trackEvent(buildVisibilityEventPath(name));
  });
  return <div ref={viewRef}>{children}</div>;
};
